<template>
  <div v-cloak>
    <transition name="fade" appear appear-active-class="fade-enter-active">
      <div v-if="apiLoaded || errorText">
        <div v-if="apiLoaded" class="wrap">
          <p>Полное название центра занятости населения: {{ regionAndDepartmentInfo.department?.fullName }}</p>
          <p>Адрес: {{ regionAndDepartmentInfo.department?.address }}</p>
          <p>Уровень центра занятости населения: {{
              regionAndDepartmentInfo.department?.type === 'territorial_czn' ? 'территориальный' : regionAndDepartmentInfo.department?.type === 'manager_czn' ? 'управляющий' : ''
            }}</p>
          <p v-if="regionAndDepartmentInfo.department?.type==='territorial_czn'">Тип территориального центра занятости населения:
          <template v-if="regionAndDepartmentInfo.department?.level == 1">первый уровень</template>
          <template v-else-if="regionAndDepartmentInfo.department?.level == 2">второй уровень</template>
          <template v-else-if="regionAndDepartmentInfo.department?.level == 3">третий уровень</template>
          <template v-else>-</template>
          </p>
          <div class="list passport" v-if="config.sections.length !== 0">
            <v-expansion-panels v-model="selectedSection">
              <v-expansion-panel v-for="(section, sectionIndex) in config.sections"
                                 class="list-item-wrap"
                                 :key="'section_' + section.id"
                                 :ref="'section_' + section.id"
                                 @change="selectedIndicator = null"
              >
                <v-expansion-panel-header>
                  <div class="list-item">
                    <a class="list-item-name">
                      <button class="toggleSwitch">
                        <svg class="closed" fill="none" height="24" viewBox="0 0 24 24"
                             width="24"
                             xmlns="http://www.w3.org/2000/svg">
                          <path d="M12 14.5L17 9.5L7 9.5L12 14.5Z" fill="#1551D0"/>
                        </svg>
                        <svg class="opened" fill="none" height="24" viewBox="0 0 24 24"
                             width="24"
                             xmlns="http://www.w3.org/2000/svg">
                          <path d="M14.5 12L9.5 7L9.5 17L14.5 12Z" fill="#1551D0"/>
                        </svg>
                      </button>
                      <span>{{ sectionIndex + 1 }}. {{ section.name }}</span>
                    </a>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-expansion-panels v-model="selectedIndicator" v-if="section.indicators.length !== 0">
                    <v-expansion-panel v-for="(indicator, indicatorIndex) in section.indicators"
                                       :key="'indicator_' + section.id + '.' + indicator.id"
                                       class="level2">
                      <div class="list-item-wrap">
                        <v-expansion-panel-header @keyup.space.prevent>
                          <div class="list-item">
                            <a class="list-item-name">
                              <button class="toggleSwitch whiteBg">
                                <svg class="closed" fill="none" height="24"
                                     viewBox="0 0 24 24" width="24"
                                     xmlns="http://www.w3.org/2000/svg">
                                  <path d="M12 14.5L17 9.5L7 9.5L12 14.5Z"
                                        fill="#1551D0"/>
                                </svg>
                                <svg class="opened" fill="none" height="24"
                                     viewBox="0 0 24 24" width="24"
                                     xmlns="http://www.w3.org/2000/svg">
                                  <path d="M14.5 12L9.5 7L9.5 17L14.5 12Z"
                                        fill="#1551D0"/>
                                </svg>
                              </button>
                              <span>{{ sectionIndex + 1 }}.{{ indicatorIndex + 1 }}. {{ indicator.name }}</span>
                            </a>
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <v-progress-circular
                                    v-on="on"
                                    :rotate="-90"
                                    :size="48"
                                    :value="getProgress(section, indicator)"
                                    :width="6"
                                    color="#0033A0"
                                >
                                  <template v-slot:default><span style="font-size: 85%">{{ getProgress(section, indicator) }}%</span></template>
                                </v-progress-circular>
                              </template>
                              Процент заполнения раздела
                            </v-tooltip>
                          </div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <table>
                            <thead>
                            <tr>
                              <th>Параметр</th>
                              <th>
                                <span>Данные
                                  <div>
                                    <v-icon class="icon-item icon-note-edit-outline" @click="showControlListDialog(section.id, indicator.id, indicator)"></v-icon>
                                      </div>

                                    </span>
                              </th>
                              <th><span>Контроль</span></th>
                            </tr>
                            </thead>
                            <tbody>

                            <template v-for="(group, groupIndex) in indicatorSequentialIndex(indicator)">
                              <tr :key="section.id + '.' + indicator.id + '.' + group.id">
                                <td colspan="3">
                                  <b>
                                    {{ sectionIndex + 1 }}.{{ indicatorIndex + 1 }}.{{ groupIndex + 1 }}. {{ group.name }}
                                  </b>
                                </td>
                              </tr>

                              <template v-for="zone in group.questions.map(q => q.zone).filter((v, i, a) => v && a.indexOf(v) === i)">
                                <tr v-if="zone" :key="zone">
                                  <td colspan="3">
                                    <u>{{ zone }}</u>
                                  </td>
                                </tr>
                                <tr v-for="question in group.questions.filter(q => q.zone === zone)" :key="section.id + '.' + indicator.id + '.' + group.id + '.' + question.id">
                                  <td>
                                    {{ sectionIndex + 1 }}.{{ indicatorIndex + 1 }}.{{ groupIndex + 1 }}.{{ question._index + 1 }}. {{ question.name }}
                                  </td>
                                  <td>
                                    <div>
                                      <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M15.8906 0H2.10938C1.54993 0 1.01341 0.172853 0.617822 0.480529C0.222237 0.788206 0 1.20551 0 1.64063L0 8.70297C0 9.13809 0.222237 9.55539 0.617822 9.86307C1.01341 10.1707 1.54993 10.3436 2.10938 10.3436H5.38312C5.42042 10.3436 5.45619 10.3551 5.48256 10.3756C5.50893 10.3961 5.52375 10.424 5.52375 10.453V13.2344C5.52374 13.3858 5.58146 13.5338 5.68962 13.6598C5.79779 13.7857 5.95153 13.8838 6.13141 13.9418C6.31129 13.9997 6.50923 14.0149 6.70019 13.9853C6.89115 13.9558 7.06655 13.8829 7.20422 13.7758L11.5748 10.3764C11.588 10.3663 11.6036 10.3583 11.6207 10.3528C11.6378 10.3474 11.6562 10.3446 11.6747 10.3447H15.8934C16.4529 10.3447 16.9894 10.1718 17.385 9.86416C17.7806 9.55648 18.0028 9.13919 18.0028 8.70406V1.64063C18.0028 1.42499 17.9482 1.21147 17.842 1.01228C17.7358 0.813088 17.5802 0.63213 17.384 0.479755C17.1878 0.327381 16.955 0.206579 16.6987 0.124258C16.4425 0.0419378 16.1679 -0.000286054 15.8906 0V0ZM17.1562 8.70297C17.1562 8.96404 17.0229 9.21442 16.7856 9.39903C16.5482 9.58364 16.2263 9.68735 15.8906 9.68735H11.6719C11.4118 9.68588 11.1615 9.76452 10.9758 9.9061L6.60938 13.3109C6.58971 13.3264 6.56458 13.3369 6.53719 13.3412C6.5098 13.3454 6.4814 13.3433 6.4556 13.3349C6.42981 13.3266 6.40778 13.3125 6.39234 13.2944C6.3769 13.2763 6.36874 13.255 6.36891 13.2333V10.453C6.36891 10.2499 6.2652 10.0552 6.08059 9.91159C5.89598 9.76801 5.6456 9.68735 5.38453 9.68735H2.10938C1.77371 9.68735 1.45179 9.58364 1.21444 9.39903C0.977092 9.21442 0.84375 8.96404 0.84375 8.70297V1.64063C0.84375 1.37955 0.977092 1.12917 1.21444 0.944568C1.45179 0.759962 1.77371 0.656252 2.10938 0.656252H15.8906C16.2263 0.656252 16.5482 0.759962 16.7856 0.944568C17.0229 1.12917 17.1562 1.37955 17.1562 1.64063V8.70297Z" fill="#777779"/>
                                      </svg>
                                      {{ (t = interpretValue(section.id, indicator.id, question.id, period)) != null ? t : "—" }}
                                    </div>
                                  </td>
                                  <td>
                                    <div>
                                      <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" :fill="checkAnswerState(getMaxControlInfo(section.id, indicator.id, question.id, period)?.flag)">
                                        <circle cx="10" cy="10" r="10"/>
                                      </svg>
                                      {{ (t = getMaxControlInfo(section.id, indicator.id, question.id, period)?.comment) != null ? t : "—" }}
                                    </div>
                                  </td>
                                </tr>
                              </template>

                              <tr v-for="question in group.questions.filter(q => !q.zone)" :key="section.id + '.' + indicator.id + '.' + group.id + '.' + question.id">
                                <td>
                                  {{ sectionIndex + 1 }}.{{ indicatorIndex + 1 }}.{{ groupIndex + 1 }}.{{ question._index + 1 }}. {{ question.name }}
                                </td>
                                <td>
                                  <div>
                                    <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M15.8906 0H2.10938C1.54993 0 1.01341 0.172853 0.617822 0.480529C0.222237 0.788206 0 1.20551 0 1.64063L0 8.70297C0 9.13809 0.222237 9.55539 0.617822 9.86307C1.01341 10.1707 1.54993 10.3436 2.10938 10.3436H5.38312C5.42042 10.3436 5.45619 10.3551 5.48256 10.3756C5.50893 10.3961 5.52375 10.424 5.52375 10.453V13.2344C5.52374 13.3858 5.58146 13.5338 5.68962 13.6598C5.79779 13.7857 5.95153 13.8838 6.13141 13.9418C6.31129 13.9997 6.50923 14.0149 6.70019 13.9853C6.89115 13.9558 7.06655 13.8829 7.20422 13.7758L11.5748 10.3764C11.588 10.3663 11.6036 10.3583 11.6207 10.3528C11.6378 10.3474 11.6562 10.3446 11.6747 10.3447H15.8934C16.4529 10.3447 16.9894 10.1718 17.385 9.86416C17.7806 9.55648 18.0028 9.13919 18.0028 8.70406V1.64063C18.0028 1.42499 17.9482 1.21147 17.842 1.01228C17.7358 0.813088 17.5802 0.63213 17.384 0.479755C17.1878 0.327381 16.955 0.206579 16.6987 0.124258C16.4425 0.0419378 16.1679 -0.000286054 15.8906 0V0ZM17.1562 8.70297C17.1562 8.96404 17.0229 9.21442 16.7856 9.39903C16.5482 9.58364 16.2263 9.68735 15.8906 9.68735H11.6719C11.4118 9.68588 11.1615 9.76452 10.9758 9.9061L6.60938 13.3109C6.58971 13.3264 6.56458 13.3369 6.53719 13.3412C6.5098 13.3454 6.4814 13.3433 6.4556 13.3349C6.42981 13.3266 6.40778 13.3125 6.39234 13.2944C6.3769 13.2763 6.36874 13.255 6.36891 13.2333V10.453C6.36891 10.2499 6.2652 10.0552 6.08059 9.91159C5.89598 9.76801 5.6456 9.68735 5.38453 9.68735H2.10938C1.77371 9.68735 1.45179 9.58364 1.21444 9.39903C0.977092 9.21442 0.84375 8.96404 0.84375 8.70297V1.64063C0.84375 1.37955 0.977092 1.12917 1.21444 0.944568C1.45179 0.759962 1.77371 0.656252 2.10938 0.656252H15.8906C16.2263 0.656252 16.5482 0.759962 16.7856 0.944568C17.0229 1.12917 17.1562 1.37955 17.1562 1.64063V8.70297Z" fill="#777779"/>
                                    </svg>
                                    {{ (t = interpretValue(section.id, indicator.id, question.id, period)) != null ? t : "—" }}
                                  </div>
                                </td>
                                <td>
                                  <div>
                                    <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" :fill="checkAnswerState(getMaxControlInfo(section.id, indicator.id, question.id, period)?.flag)">
                                      <circle cx="10" cy="10" r="10"/>
                                    </svg>
                                    {{ (t = getMaxControlInfo(section.id, indicator.id, question.id, period)?.comment) != null ? t : "—" }}
                                  </div>
                                </td>
                              </tr>
                            </template>

                            <tr style="margin-top:20px"><b>Документы</b></tr>
                            <tr v-for="(source, sourceIndex) in getSourcesArray(indicator)"
                                :key="section.id+'_'+ indicator.id + '_'+sourceIndex+'_source'">
                              <td>
                                {{ source }}
                              </td>
                              <td v-if="getAttachments(section.id, indicator.id, period, source).length>0">
                                <template
                                    v-for="attachment in getAttachments(section.id, indicator.id, period, source)">
                                  <div :key="attachment.file.id + 'fileIndex'" class="d-flex align-center">
                                    <svg width="10" height="20" viewBox="0 0 10 20" fill="none"
                                         xmlns="http://www.w3.org/2000/svg"
                                         class="mr-2">
                                      <path
                                          d="M8.94029 5.78581C8.59471 5.78581 8.31597 6.05336 8.31597 6.39919V15.4626C8.31597 16.388 7.98158 17.146 7.33488 17.7927C6.68819 18.4394 5.91905 18.7738 4.98271 18.7738C4.06847 18.7738 3.28814 18.4505 2.64147 17.8039C1.99481 17.1572 1.67158 16.3769 1.67158 15.4626V12.0402V10.2119V5.7078V3.54518V3.5228V3.50045C1.67158 2.88732 1.89728 2.35505 2.32943 1.91742C2.76705 1.47434 3.29908 1.23745 3.93481 1.23745C4.57031 1.23745 5.10259 1.47434 5.53993 1.91742C5.97208 2.35505 6.19781 2.88732 6.19781 3.50045V3.5228V3.5673V13.6791C6.19781 14.3143 5.70738 14.805 5.0719 14.805C4.45875 14.805 3.95693 14.2922 3.95693 13.6791V8.38343C3.95693 8.03785 3.68935 7.7703 3.3438 7.7703C2.99824 7.7703 2.73067 8.03785 2.73067 8.38343V13.6791C2.73067 14.3367 2.95375 14.8942 3.41064 15.3513C3.86776 15.8084 4.41408 16.0313 5.07193 16.0313C5.72953 16.0313 6.28152 15.8027 6.74413 15.3513C7.19579 14.9106 7.42413 14.3591 7.42413 13.6791V3.5228V3.50045C7.42413 2.54174 7.07569 1.71955 6.39857 1.03672C5.71572 0.348182 4.89352 0 3.93481 0C2.97587 0 2.15367 0.348182 1.47084 1.03672C0.793747 1.71955 0.445312 2.54174 0.445312 3.50045V3.5228V5.7078V10.2119V12.0402V15.4626C0.445312 16.7224 0.891247 17.7927 1.77195 18.6733C2.65266 19.554 3.72289 20 4.98271 20C6.24254 20 7.33488 19.5764 8.22678 18.6845C9.11865 17.7927 9.55342 16.7003 9.55342 15.4626V6.39919C9.55342 6.05336 9.28584 5.78581 8.94029 5.78581Z"
                                          fill="#777779"/>
                                    </svg>
                                    <a :href="$backendUrl+'/s3/' + attachment.file.id"
                                       @click.prevent="downloadFile(attachment.file.id, attachment.file.name)">
                                      {{ truncateStr(attachment.file.name, 30) }}
                                    </a>
                                  </div>
                                </template>
                              </td>
                              <td v-else>&mdash;</td>
                            </tr>
                            </tbody>
                          </table>

                        </v-expansion-panel-content>
                      </div>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </div>
      </div>
      <div v-else style="height:1000px"></div>
    </transition>
    <v-dialog
        v-model="controlListDialog"
        max-width="1150px"
        persistent>

      <OrgMonitorControlDialog
          v-if="controlListDialog"
          @close="controlListDialog=false; orgMonitorControlDialog++"
          :region-and-department-info="regionAndDepartmentInfo"
          :indicator-config="controlListDialogIndicatorConfig"
          :values="checklistValues"
          :attachments="attachments"
          :period="period"
          :section-id="controlListDialogSectionId"
          :indicator-id="controlListDialogIndicatorId"
          @updated="editDialogUpdated"
          :key="orgMonitorControlDialog"/>
    </v-dialog>
  </div>
</template>

<script>

import OrgMonitorControlDialog from "@/components/orgmonitor/OrgMonitorControlDialog";
import {orgMonitorConfig, orgMonitorConfig2024} from "@/modules/OrgMonitorConfig";
import api from "@/modules/api";
import {
  loadAttachmentsByDepartmentIdAndPeriod,
  loadValuesByDepartmentIdAndPeriod,
  loadValuesByRegionCodeAndPeriod
} from "@/modules/OrgMonitor";

export default {
  name: "OrgMonitorCheckList",
  components: {
    OrgMonitorControlDialog
  },
  props: ['regionAndDepartmentInfo', 'period'],
  watch: {
    regionAndDepartmentInfo: {
      async handler() {
        this.apiLoaded = false;
        await this.initialize();
        this.$forceUpdate();
        this.apiLoaded = true;
      },
      deep: true
    },
    period: {
      async handler() {
        this.apiLoaded = false;
        await this.initialize();
        this.$forceUpdate();
        this.apiLoaded = true;
      }
    }
  },

  data: () => ({
    id: null,
    attachments: [],
    config: orgMonitorConfig,
    orgMonitorControlDialog: 0,
    checklistValues: [],
    apiLoaded: false,
    errorText: null,
    dialog: false,
    checkListDialog: false,
    controlListDialog: false,
    controlListDialogSectionId: null,
    controlListDialogIndicatorId: null,
    controlListDialogIndicatorConfig: null,
    selectedSection: null,
    selectedIndicator: null,
  }),

  methods: {
    //Для сквозной нумерации вопросов без учета зон
    indicatorSequentialIndex(indicator) {
      return indicator.groups.map(group => {
        let index = 0
        group.questions.forEach(question => {
          question._index = index++
        })
        return group
      })
    },
    filterConfig() {
      this.config = {sections: []}
      // какой уровень у выбранного цзн
      const level = this.regionAndDepartmentInfo.department?.type === 'territorial_czn' ? 'ТЦЗН' : 'УЦЗН'
      for (let section of this.period > 5 ? orgMonitorConfig2024.sections: orgMonitorConfig.sections) {
        const sectionToAdd = {id: section.id, name: section.name, indicators: []}
        for (let indicator of section.indicators) {
          if (indicator.level === level || (indicator.level === 'Рабочее_место' && level === 'ТЦЗН')) {
            sectionToAdd.indicators.push(indicator)
          }
        }
        if (sectionToAdd.indicators.length > 0) {
          this.config.sections.push(sectionToAdd)
        }
      }
    },

    async initialize() {
      this.filterConfig()
      await this.loadValues()
      this.selectSectionAndIndicator()
    },

    async loadValues() {
      if (this.regionAndDepartmentInfo.department != null) {
        this.checklistValues = await loadValuesByDepartmentIdAndPeriod(this.regionAndDepartmentInfo.department.id, this.period)
        this.attachments = await loadAttachmentsByDepartmentIdAndPeriod(this.regionAndDepartmentInfo.department.id, this.period)
      } else {
        this.checklistValues = await loadValuesByRegionCodeAndPeriod(this.regionAndDepartmentInfo.region.code, this.period)
        this.attachments = []
      }
    },

    getProgress(section, indicator) {
      return Math.round(
          (this.getSectionValuesPresent(section, indicator) /
              this.getSectionValuesCount(section, indicator)) *
          100
      );
    },

    getValue(sectionId, indicatorId, questionId, period) {
      const valsFound = this.checklistValues.filter(
          e => e.period === period && e.sectionId === sectionId && e.indicatorId === indicatorId && e.questionId === questionId
      )
      if(valsFound.length > 1){
        alert('Найдено более двух значений одного показателя за период. Пожалуйста, сообщите об ошибке администратору')
      }
      return valsFound[0]
    },

    getAttachments(sectionId, indicatorId, period, source) {
      return this.attachments.filter(
          e => e.period === period && e.sectionId === sectionId && e.indicatorId === indicatorId && e.source === source && !e.deleted
      )
    },

    getSourcesArray(indicator) {
      let sources = indicator.sources.split('\n')
      sources.push('Иные')
      return sources
    },

    interpretValue(sectionId, indicatorId, questionId) {
      let value = this.getValue(sectionId, indicatorId, questionId, this.period)?.comment
      if (!value) return value
      let groups = this.config.sections.find(e => e.id === sectionId)?.indicators?.find(e => e.id === indicatorId)?.groups
      if (!groups) return value
      let indicatorType
      for (let group of groups) {
        indicatorType = group.questions.find(e => e.id === questionId)?.type
        if (indicatorType) break
      }

      if (indicatorType === 'boolean' || indicatorType === 'DICT_SECTORS') {
        switch (value) {
          case '0':
            return 'Нет'
          case '1':
            return 'Да'
          case '2':
            return 'Совмещено'
        }
      }
      return value
    },

    getMaxControlInfo(sectionId, indicatorId, questionId){
      let questionValue = this.getValue(sectionId, indicatorId, questionId, this.period)
      if(!questionValue || !questionValue.controlInfo) return null
      return questionValue.controlInfo.find(e=>e.controlLevel==='MINTRUD') ||
          questionValue.controlInfo.find(e=>e.controlLevel==='VNII') ||
          questionValue.controlInfo.find(e=>e.controlLevel==='ROIV') ||
          questionValue.controlInfo.find(e => e.controlLevel === 'CZN')
    },

    showControlListDialog(sectionId, indicatorId, indicatorConfig) {
      this.controlListDialogSectionId = sectionId
      this.controlListDialogIndicatorId = indicatorId
      this.controlListDialogIndicatorConfig = indicatorConfig
      this.controlListDialog = true
    },

    async editDialogUpdated(dialog) {
      this.controlListDialog = false
      await this.loadValues();
      dialog.setLocalValues()
      this.$forceUpdate()
    },

    truncateStr(str, n = 30) {
      if (!str) return str
      if (str.length > n) {
        return str.substring(0, n - 3) + "..." + str.substring(str.length - 6, str.length)
      }
      return str;
    },

    async downloadFile(fileId, fileName) {
      let req = await api.download("/s3/" + fileId, {});
      if (req.ok) {
        let link = document.createElement('a');
        link.href = URL.createObjectURL(req.payload);
        link.download = fileName;
        link.click();
        URL.revokeObjectURL(link.href);
      } else {
        console.log('download error');
      }
    },

    checkAnswerState(flag) {
      if (flag == null) {
        return 'none';
      } else if (flag === 3) {
        return 'red';
      } else if (flag === 2) {
        return 'yellow'
      } else if (flag === 1) {
        return 'green'
      }
    },

    isEmptyValue(value) {
      if (value == null) return true
      return (value.comment == null || value.comment.length === 0)
    },

    getSectionValuesPresent(section, indicator) {
      let count = 0;
      for (let group of indicator.groups) {
        for (let question of group.questions) {
          if (!this.isEmptyValue(this.getValue(section.id, indicator.id, question.id, this.period))) {
            count++
          }
        }
      }
      return count;
    },

    //считает количество вопросов в разделе (по конфигу)
    getSectionValuesCount(section, indicator) {
      let count = 0;
      for (let group of indicator.groups)
        count += group.questions.length;
      return count;
    },

    selectSectionAndIndicator() {
      const sectionId = this.$route.query.sectionId;
      const indicatorId = this.$route.query.indicatorId;

      if (sectionId && indicatorId) {
        const sectionIndex = this.config.sections.findIndex(section => section.id === +sectionId)
        const section = this.config.sections[sectionIndex]

        if (section) {
          this.selectedSection = sectionIndex
          this.selectedIndicator = section.indicators.findIndex(indicator => indicator.id === +indicatorId)

          this.$nextTick(() => {
            setTimeout(() => {
              const element = this.$refs['section_' + section.id];
              if (element && element[0]) {
                element[0].$el.scrollIntoView({behavior: 'smooth'});
              }
            }, 1000);
          })
        }
      }
    }
  },

  filters: {
    dateFormat: function (date) {
      if (date == null) {
        return ''
      }
      let mdate = new Date(date)
      let options = {timeZone: 'Europe/Moscow', year: 'numeric', month: 'numeric', day: 'numeric'}
      return mdate.toLocaleDateString('ru-RU', options)
    }
  },

  async beforeMount() {
    await this.initialize()
    this.apiLoaded = true;
  },
  mounted() {

  }
}
</script>

<style scoped lang="scss">
@import "../../styles/main";

h1 {
  display: flex;
  align-items: center;

  .badge {
    width: 152px;
    height: 60px;
    background: #E8E8E9;
    border: 1px solid #E8E8E9;
    border-radius: 4px;
    font-size: 14px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-left: 70px;
    color: $cblack;
  }

  .v-progress-circular {
    margin-left: 20px;
  }

  .v-btn {
    margin-left: auto;
  }
}

.manual-link {
  margin: 20px 0;

  a {
    display: flex;
    align-items: center;
    text-decoration: none;
    margin-bottom: 20px;

    .v-icon {
      color: #0033a0;
      margin-right: 10px;
    }
  }
}

.list {
  .list-item-wrap {
    padding: 5px 0;
  }

  table {
    margin-bottom: 25px;

    th {
      padding: 5px 20px 5px 0;

      div.v-dialog__container + div {
        height: 24px;
        cursor: pointer;
      }

      span {
        display: flex;
        justify-content: flex-start;
        gap: 3px;
        min-width: min(150px, 20vw);
      }

      &:first-child {
        text-align: center;
        width: 100%;
      }
    }

    td {
      padding: 5px 20px 5px 0;
      border-top: 1px solid #E8E8E9;
      border-bottom: 0;

      & > div {
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;

        svg {
          margin-right: 8px;
          flex-shrink: 0;
          margin-top: 5px;
          width: 20px;
        }

        a {
          white-space: nowrap;
        }
      }
    }

    tr:last-child {
      td {
        border-top: 1px solid #E8E8E9;
      }
    }
  }
}

.clientindex {
  .v-expansion-panel.level2 {
    padding-left: 30px;
    padding-top: 0px;

    .list-item-wrap {
      border-bottom: 0;
    }

    & + .v-expansion-panel.level2 {
      .list-item-wrap {
        border-top: 1px solid #E8E8E9;
      }
    }
  }
}

.push-right {
  float: right;
  margin-top: 15px;
}

.v-progress-circular__info {
  font-size: 13px !important;
  text-align: center;
  width: 100%;
}
</style>
